import React from 'react';
import { useMessages } from '@ynap/immutables-provider';

export const SizeGuideWatches = () => {
    const sizeGuideWatches = useMessages((messages) => messages.sizes.watchSizeGuide.title);
    return <>{sizeGuideWatches()}</>;
};

export const SizeGuideDefault = () => {
    const sizeGuideDefault = useMessages((messages) => messages.sizes.sizeGuide.title);
    return <>{sizeGuideDefault()}</>;
};
